import PropTypes from "prop-types";
import React from "react";

export const Pool = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path
        d="M1.3335 13.9999V12.9333C1.7335 12.8999 2.05294 12.7833 2.29183 12.5833C2.53072 12.3833 2.90572 12.2833 3.41683 12.2833C3.92794 12.2833 4.34461 12.4027 
4.66683 12.6416C4.98905 12.8805 5.36127 12.9999 5.7835 12.9999C6.20572 12.9999 6.55294 12.8805 6.82516 12.6416C7.09738 12.4027 7.48905 12.2833 8.00016 
12.2833C8.51127 12.2833 8.92794 12.4027 9.25016 12.6416C9.57238 12.8805 9.94461 12.9999 10.3668 12.9999C10.7891 12.9999 11.1391 12.8805 11.4168 12.6416C11.6946 
12.4027 12.0891 12.2833 12.6002 12.2833C13.1113 12.2833 13.4835 12.3833 13.7168 12.5833C13.9502 12.7833 14.2668 12.8999 14.6668 12.9333V13.9999C14.2779 13.9666 
13.9418 13.8416 13.6585 13.6249C13.3752 13.4083 13.0224 13.2999 12.6002 13.2999C12.1779 13.2999 11.8168 13.4166 11.5168 13.6499C11.2168 13.8833 10.8335 13.9999 
10.3668 13.9999C9.90016 13.9999 9.49461 13.8833 9.15016 13.6499C8.80572 13.4166 8.42238 13.2999 8.00016 13.2999C7.57794 13.2999 7.2085 13.4166 6.89183 
13.6499C6.57516 13.8833 6.1835 13.9999 5.71683 13.9999C5.25016 13.9999 4.85572 13.8833 4.5335 13.6499C4.21127 13.4166 3.83905 13.2999 3.41683 13.2999C2.99461 13.2999 2.63905 13.4083 2.35016 13.6249C2.06127 13.8416 1.72238 13.9666 1.3335 13.9999ZM1.3335 10.8666V9.86661C1.7335 9.83328 2.05294 9.71939 2.29183 9.52494C2.53072 9.3305 2.90572 9.23328 3.41683 9.23328C3.92794 9.23328 4.3335 9.33883 4.6335 9.54994C4.9335 9.76105 5.29461 9.86661 5.71683 9.86661C6.13905 9.86661 6.49738 9.76105 6.79183 9.54994C7.08627 9.33883 7.48905 9.23328 8.00016 9.23328C8.51127 9.23328 8.91683 9.33883 9.21683 9.54994C9.51683 9.76105 9.87794 9.86661 10.3002 9.86661C10.7224 9.86661 11.0835 9.76105 11.3835 9.54994C11.6835 9.33883 12.0891 9.23328 12.6002 9.23328C13.1113 9.23328 13.4835 9.3305 13.7168 9.52494C13.9502 9.71939 14.2668 9.83328 14.6668 9.86661V10.8666C14.2779 10.8333 13.9418 10.7083 13.6585 10.4916C13.3752 10.2749 13.0224 10.1666 12.6002 10.1666C12.1779 10.1666 11.8168 10.2833 11.5168 10.5166C11.2168 10.7499 10.8335 10.8666 10.3668 10.8666C9.90016 10.8666 9.49461 10.7499 9.15016 10.5166C8.80572 10.2833 8.42238 10.1666 8.00016 10.1666C7.57794 10.1666 7.21961 10.2833 6.92516 10.5166C6.63072 10.7499 6.25016 10.8666 5.7835 10.8666C5.31683 10.8666 4.91127 10.7499 4.56683 10.5166C4.22238 10.2833 3.83905 10.1666 3.41683 10.1666C2.99461 10.1666 2.63905 10.2749 2.35016 10.4916C2.06127 10.7083 1.72238 10.8333 1.3335 10.8666ZM4.80016 7.39994L7.05016 5.14994L6.15016 4.24994C5.77238 3.87217 5.38905 3.61939 5.00016 3.49161C4.61127 3.36383 4.11683 3.29994 3.51683 3.29994V1.98328C4.31683 1.98328 4.97516 2.08328 5.49183 2.28328C6.0085 2.48328 6.51127 2.82772 7.00016 3.31661L11.2168 7.53328C11.0946 7.63328 10.9529 7.7055 10.7918 7.74994C10.6307 7.79439 10.4668 7.81661 10.3002 7.81661C9.87794 7.81661 9.51405 7.69994 9.2085 7.46661C8.90294 7.23328 8.50016 7.11661 8.00016 7.11661C7.50016 7.11661 7.10016 7.23328 6.80016 7.46661C6.50016 7.69994 6.13905 7.81661 5.71683 7.81661C5.51683 7.81661 5.33627 7.77772 5.17516 7.69994C5.01405 7.62216 4.88905 7.52216 4.80016 7.39994ZM11.1335 2.04994C11.5779 2.04994 11.9529 2.20272 12.2585 2.50828C12.5641 2.81383 12.7168 3.18883 12.7168 3.63328C12.7168 4.07772 12.5641 4.45272 12.2585 4.75828C11.9529 5.06383 11.5779 5.21661 11.1335 5.21661C10.6891 5.21661 10.3141 5.06383 10.0085 4.75828C9.70294 4.45272 9.55016 4.07772 9.55016 3.63328C9.55016 3.18883 9.70294 2.81383 10.0085 2.50828C10.3141 2.20272 10.6891 2.04994 11.1335 2.04994Z"
      />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 -1 16 16",
    };
  }
};

Pool.displayName = "PoolIcon";

Pool.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Pool.defaultProps = { role: "img" };
